<div class="pure-menu pure-menu-horizontal">
  <span class="pure-menu-heading">Request Permissions</span>
</div>
<div class="container">
  <!-- Request permissions Form-->
  <form
    [formGroup]="requestPermissionForm"
    (ngSubmit)="submit()"
    class="pure-form pure-form-stacked"
  >
    <!-- Select option for request access type -->
    <div class="pure-control-group">
      <label for="requestAccessType">Request Access</label>
      <select
        formControlName="requestAccessType"
        id="requestAccessType"
        class="pure-input-2-3"
        (change)="onRequestAccessTypeChange()"
      >
        <option
          *ngFor="let option of requestAccessTypeList"
          [value]="option?.value"
        >
          {{ option?.label }}
        </option>
      </select>
    </div>

    <!-- Select option for uiPageType -->
    <div
      class="pure-control-group"
      *ngIf="
        requestPermissionForm.get('requestAccessType').value ===
        viewLabelValues.otherRequest
      "
    >
      <label class="pure-checkbox" *ngFor="let option of uiPageTypeList">
        <input
          type="checkbox"
          [id]="option?.value"
          [value]="option?.value"
          [checked]="requestPermissionForm.get('uiPageType').value.includes(option?.value)"
          #uiPageType
          (change)="onUIPageTypeChange(uiPageType.value)"
        />
        {{ option?.label }}
        <ul>
          <li *ngFor="let page of uiPageTypes[option?.value]">
            {{ page?.label }}
          </li>
        </ul>
      </label>
    </div>

    <!-- Select option for From Country Code Options -->
    <div class="pure-control-group">
      <label for="fromCountryCodeId">From Country Code </label>
      <select
        id="fromCountryCodeId"
        class="pure-input-2-3"
        formControlName="fromCountryCode"
        #fromCountryCode
        (change)="onFromCountryCodeChange(fromCountryCode.value)"
      >
        <option
          *ngFor="let _fromCountryCode of fromCountryCodeOptions; let i = index"
          [value]="_fromCountryCode"
        >
          {{ _fromCountryCode }}
        </option>
      </select>
    </div>

    <div class="pure-control-group">
      <label for="businessUseCase">Business Use Case </label>
      <select
        name="businessUseCase"
        id="businessUseCase"
        class="pure-input-2-3"
        formControlName="businessUseCase"
        #businessUseCaseRef
        (change)="onBusinessUseCaseChange(businessUseCaseRef.value)"
      >
        <ng-template ngFor let-item [ngForOf]="getItems">
          <optgroup label="{{ item.name }}">
            <option
              *ngFor="let usecase of item.usecases"
              [value]="usecase | json"
            >
              {{ usecase.text }}
            </option>
          </optgroup>
        </ng-template>
      </select>
    </div>

    <div
      *ngIf="
        requestPermissionForm.get('requestAccessType').value ===
          viewLabelValues.otherRequest &&
        requestPermissionForm.get('businessUseCase')?.value
      "
    >
      <div *ngIf="currentComponentKeyPlaceholder?.length === 1">
        <!-- Radio buttons for componentKeyValue selectors -->
        <div formGroupName="componentKeyValueSelector">
          <div *ngFor="let field of currentComponentKeyPlaceholder">
            <div class="pure-control-group">
              <label>All {{ field }}</label>
              <label
                class="pure-radio"
                *ngFor="let selectOption of userConsentSelectOptions"
              >
                <input
                  type="radio"
                  [formControlName]="field"
                  [value]="selectOption"
                  (change)="
                    onComponentKeyValueSelectorChangeOne(field, selectOption)
                  "
                />
                {{ selectOption }}
              </label>
            </div>
          </div>
        </div>
        <!-- Dynamic entries for Component Key Placeholder parts -->
        <div
          *ngIf="
            requestPermissionForm
              ?.get('componentKeyValueSelector')
              ?.get(currentComponentKeyPlaceholder[0])?.value ===
            userConsentEnum.NO
          "
        >
          <div formGroupName="componentKeyValue">
            <div *ngFor="let field of currentComponentKeyPlaceholder">
              <app-multi-select-input
                [label]="field"
                [selectOptionList]="dropDownOptions[field]"
                [selectedOptions]="
                  requestPermissionForm.get('componentKeyValue')?.get(field)
                    ?.value
                "
                (selectOptionUpdated)="onSelectOptionUpdated($event, field)"
              ></app-multi-select-input>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="currentComponentKeyPlaceholder?.length === 2">
        <!-- Radio buttons for componentKeyValue selectors -->
        <div formGroupName="componentKeyValueSelector">
          <div
            *ngFor="let field of currentComponentKeyPlaceholder; let i = index"
          >
            <div
              class="pure-control-group"
              *ngIf="
                i === 0 ||
                (i > 0 &&
                  requestPermissionForm
                    ?.get('componentKeyValueSelector')
                    ?.get(currentComponentKeyPlaceholder[0])?.value ===
                    userConsentEnum.NO)
              "
            >
              <label>All {{ field }}</label>
              <label
                class="pure-radio"
                *ngFor="let selectOption of userConsentSelectOptions"
              >
                <input
                  type="radio"
                  [formControlName]="field"
                  [value]="selectOption"
                  (change)="onComponentKeyValueSelectorChangeTwo()"
                />
                {{ selectOption }}
              </label>
            </div>
          </div>
        </div>
        <!-- Dynamic entries for Component Key Placeholder parts -->
        <div
          *ngIf="
            requestPermissionForm
              ?.get('componentKeyValueSelector')
              ?.get(currentComponentKeyPlaceholder[0])?.value ===
            userConsentEnum.NO
          "
        >
          <div
            *ngIf="
              requestPermissionForm
                ?.get('componentKeyValueSelector')
                ?.get(currentComponentKeyPlaceholder[1])?.value ===
              userConsentEnum.YES
            "
          >
            <div formGroupName="componentKeyValue">
              <div
                *ngFor="
                  let field of currentComponentKeyPlaceholder;
                  let i = index
                "
              >
                <app-multi-select-input
                  *ngIf="i === 0"
                  [label]="field"
                  [selectOptionList]="dropDownOptions[field]"
                  [selectedOptions]="
                    requestPermissionForm.get('componentKeyValue')?.get(field)
                      ?.value
                  "
                  (selectOptionUpdated)="onSelectOptionUpdated($event, field)"
                ></app-multi-select-input>
              </div>
            </div>
          </div>
          <div
            *ngIf="
              requestPermissionForm
                ?.get('componentKeyValueSelector')
                ?.get(currentComponentKeyPlaceholder[1])?.value ===
              userConsentEnum.NO
            "
          >
            <div formGroupName="componentKeyValue">
              <div
                *ngFor="
                  let field of currentComponentKeyPlaceholder;
                  let i = index
                "
              >
                <div class="pure-control-group" *ngIf="i === 0">
                  <label
                    >{{ field }}
                    <select
                      class="pure-input-2-3"
                      [formControlName]="field"
                      #carrierName
                      (change)="
                        updateShipmethodOnCarrierNameChange(carrierName.value)
                      "
                    >
                      <option
                        *ngFor="
                          let option of dropDownOptions[field];
                          let i = index
                        "
                        [value]="option"
                      >
                        {{ option }}
                      </option>
                    </select>
                  </label>
                </div>
                <app-multi-select-input
                  *ngIf="i === 1"
                  [label]="field"
                  [selectOptionList]="dropDownShipmethodOptions"
                  [selectedOptions]="
                    requestPermissionForm.get('componentKeyValue')?.get(field)
                      ?.value
                  "
                  (selectOptionUpdated)="onSelectOptionUpdated($event, field)"
                ></app-multi-select-input>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Select option for transit time type -->
      <div
        class="pure-control-group"
        *ngIf="
          requestPermissionForm.get('requestAccessType').value ===
          viewLabelValues.otherRequest
        "
      >
        <label for="transitTimeType">Select Transit Time Type</label>
        <select
          formControlName="transitTimeType"
          id="transitTimeType"
          class="pure-input-2-3"
        >
          <option *ngFor="let option of transitTimeOptions" [value]="option">
            {{ option }}
          </option>
        </select>
      </div>
    </div>

    <!-- Input for request reason-->
    <label for="requestReason">Reason for permission request</label>
    <textarea
      id="requestReason"
      class="pure-input-2-3"
      type="text"
      formControlName="requestReason"
    ></textarea>

    <!-- Submit button-->
    <div>
      <button
        class="pure-button pure-button-primary button-large"
        type="submit"
        [disabled]="requestPermissionForm.invalid || loading"
      >
        Submit
      </button>
    </div>
  </form>
  <app-loader [loading]="loading" [size]="'small'"></app-loader>
</div>
